export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hand_Roughness.6dc1b7dd.tga";